"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function CallsInQueueIcon() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "34", height: "34", viewBox: "0 0 34 34", id: "calls-in-queue-icon" },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "#767F8C", d: "M23.987 13h2.025C29.358 13 32 16.141 32 20H18c0-3.859 2.642-7 5.987-7M25 11c-1.628 0-3-1.305-3-2.957S23.372 5 25 5c1.63 0 3 1.304 3 2.957C28 9.609 26.63 11 25 11" }),
            React.createElement("path", { fill: "#B2B9C2", d: "M11 16.194C12.056 14.273 13.894 13 16.017 13h2.016C21.368 13 24 16.141 24 20h-9.211L11 16.194zM17 11c-1.628 0-3-1.305-3-2.957S15.372 5 17 5c1.63 0 3 1.304 3 2.957C20 9.609 18.63 11 17 11" }),
            React.createElement("path", { fill: "#B2B9C2", d: "M4 10.453v9.183L14.365 30h9.198L27 26.575l-4.573-4.596-4.618 4.622L7.391 16.208l4.624-4.66L7.415 7z" }),
            React.createElement("path", { fill: "#DEDFE1", d: "M7.438 16L4 19.48 14.508 30 18 26.55z" }))));
}
exports.CallsInQueueIcon = CallsInQueueIcon;
